// MainContainer.tsx
import React from "react";

interface MainContainerProps {
  children: React.ReactNode;
  zDepth: number;
  minY?: number;
  color?: boolean;
}

export const MasterDiv: React.FC<MainContainerProps> = ({
  children,
  zDepth,
  color,
}) => {
  return (
    <div
      style={{
        backgroundColor: color ? "rgb(19, 22, 24)" : "",
        position: "absolute", // or 'fixed' depending on need
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: zDepth,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
};
